import 'babel-polyfill';
import "react-app-polyfill/ie11";
import React from 'react';
import ReactDOM from 'react-dom';
import { compose, bindActionCreators } from 'redux';
import { Provider, connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import registerServiceWorker from './registerServiceWorker';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import en_US from './i18n/en_US'
import ja_JP from './i18n/ja_JP'
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import App from './App';
import { initIntl } from './utils';
import blue from '@material-ui/core/colors/blue';
import orange from '@material-ui/core/colors/deepOrange';

var develop_debug = false;
addLocaleData([...en, ...ja])

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

// language (ex.  "en"、"en-US"、"ja"、 "ja-JP" https://developer.mozilla.org/ja/docs/Web/API/NavigatorLanguage/language )
//const locale = navigator.language.split('_')[0]
const locale = navigator.language.split('-')[0]

const chooseLocale = (locale) => {
    switch (locale) {
        case 'en':
            return en_US
        case 'ja':
            return ja_JP
        default:
            return en_US
    }
}

// ここでテーマを上書きできる
// https://material-ui.com/customization/themes/
const theme = createMuiTheme({
    palette: {
        primary: blue,
        secondary: orange,
    },
    loadingBackground: {
        zIndex: '9998',
        position: 'fixed',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgb(255, 255, 255)',
        opacity: 0.8
    },
    loading: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        marginTop: '-20px',
        marginLeft: '-20px',
        zIndex: '9999',
    }
});

const messages = chooseLocale(locale);

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <IntlProvider locale={locale} messages={messages}>
                    <App />
                </IntlProvider>
            </ConnectedRouter>
        </Provider>
    </MuiThemeProvider>,
    rootElement);

registerServiceWorker();

// 共通メソッドの国際化対応ライブラリを初期化
initIntl(locale, messages );
